export default __webpack_public_path__ + "static/media/7.SquarepharmaceuticalsLtd.,Gazipur.08997b65.jpg";